import * as React from "react"

import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { CellType, RowContentCell } from "@tenforce/toolbox-table-react"

import LoadMore from "../LoadMore"

interface Props {
    loadMoreLabel: string
    pageSize: number
    workspaceChildren: Navigation.NavigationItem[]
    onNavigate: () => void
}

interface State {
    limit: number
}

export default class WorkspaceChildren extends React.PureComponent<
    Props,
    State
> {
    constructor(props: Props) {
        super(props)
        this.state = {
            limit: props.pageSize,
        }
    }

    render(): JSX.Element {
        const { workspaceChildren, loadMoreLabel, onNavigate } = this.props
        const { limit } = this.state

        return (
            <>
                {workspaceChildren.slice(0, limit).map((child, index) => (
                    <RowContentCell
                        key={index}
                        cellProps={{ type: CellType.action }}
                        data-ft-list={
                            !child.isSmartlist ? child.text.toLowerCase() : null
                        }
                        data-ft-smartlist={
                            child.isSmartlist ? child.text.toLowerCase() : null
                        }
                        data-ft-component="workspaceChildRow"
                    >
                        <ActionAnchor
                            href={child.url}
                            actionType={ActionType.block}
                            extraClasses="text-black tw-px-3"
                            onClick={onNavigate}
                            title={child.text}
                            data-ft-component="workspaceChildLink"
                        >
                            <div className="tw-truncate">{child.text}</div>
                        </ActionAnchor>
                    </RowContentCell>
                ))}
                {limit < workspaceChildren.length && (
                    <LoadMore
                        loadMoreLabel={loadMoreLabel}
                        loadMore={this.loadMore}
                        data-ft-load-more="navigationWorkspacesChildren"
                    />
                )}
            </>
        )
    }

    loadMore = (): void => {
        const { pageSize } = this.props
        const { limit } = this.state
        const newLimit = limit + pageSize
        this.setState({ limit: newLimit })
    }
}
